import "core-js/modules/es.array.concat";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib"; // TODO 测试

import { Vue, Component, Prop } from 'vue-property-decorator';
import apis from '@/apis/caseManage';
import EZUIKit from 'ezuikit-js';
import downloadFile from '@/apis/downloadFile';
import { formatProtocol } from '@/utils/index';

var VideoIframe = /*#__PURE__*/function (_Vue) {
  _inherits(VideoIframe, _Vue);

  var _super = _createSuper(VideoIframe);

  function VideoIframe() {
    var _this;

    _classCallCheck(this, VideoIframe);

    _this = _super.apply(this, arguments);
    _this.player = null;
    return _this;
  }

  _createClass(VideoIframe, [{
    key: "startRecord",
    value: function startRecord() {
      if (this.isCloud) {
        this.initCloudPlayer();
      } else {
        this.initEZUIKitPlayer();
      }
    } // 初始化本地录像播放器

  }, {
    key: "initEZUIKitPlayer",
    value: function initEZUIKitPlayer() {
      var _this2 = this;

      document.getElementById("video-container-".concat(this.index)).innerHTML = '';
      apis.trialVideo({
        scheduleId: this.recordDetail.courtScheduleId
      }).then(function (res) {
        var url = "".concat(res.data.playBackUrl, "?begin=").concat(_this2.$moment(_this2.recordDetail.startTime).format('YYYYMMDDHHmmss'), "&end=").concat(_this2.$moment(_this2.recordDetail.endTime).format('YYYYMMDDHHmmss'));
        _this2.player = new EZUIKit.EZUIKitPlayer({
          autoplay: true,
          id: "video-container-".concat(_this2.index),
          accessToken: res.data.ezvizToken,
          url: url,
          template: 'security',
          // 视频上方头部控件
          header: ['capturePicture', 'save'],
          // plugin: ['talk'],                       // 加载插件，talk-对讲
          // 视频下方底部控件
          footer: ['hd', 'fullScreen'],
          // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
          // openSoundCallBack: data => console.log("开启声音回调", data),
          // closeSoundCallBack: data => console.log("关闭声音回调", data),
          // startSaveCallBack: data => console.log("开始录像回调", data),
          // stopSaveCallBack: data => console.log("录像回调", data),
          // capturePictureCallBack: data => console.log("截图成功回调", data),
          // fullScreenCallBack: data => console.log("全屏回调", data),
          // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
          width: 810,
          height: 450
        });
      }).catch(function (_) {});
    } // 初始化云储存播放器

  }, {
    key: "initCloudPlayer",
    value: function initCloudPlayer() {
      if (this.recordDetail.liveLogApiDTOs.length) {
        document.getElementById("video-container-".concat(this.index)).innerHTML = this.recordDetail.liveLogApiDTOs[0].iframe;
      } else {
        this.$message('暂无录像数据');
      }
    }
  }, {
    key: "downloadVideo",
    value: function downloadVideo() {
      if (this.recordDetail.liveLogApiDTOs && this.recordDetail.liveLogApiDTOs[0] && this.recordDetail.liveLogApiDTOs[0].downloadUrl) {
        try {
          var downFile = document.getElementById('downfile');
          downFile.src = formatProtocol(this.recordDetail.liveLogApiDTOs[0].downloadUrl); // window.location.href = formatProtocol(this.recordDetail.liveLogApiDTOs[0].downloadUrl)
        } catch (e) {
          this.$message.error('下载异常，请重试');
        }
      } else {
        this.$message('暂无录像数据');
      }
    }
  }, {
    key: "downloadNote",
    value: function downloadNote() {
      var _this3 = this;

      apis.trialNote({
        scheduleId: this.recordDetail.courtScheduleId
      }).then(function (res) {
        if (res.data) {
          var downLoadPath = "".concat(window.location.protocol, "//").concat(window.location.host).concat(downloadFile, "?id=").concat(res.data);

          try {
            var downFile = document.getElementById('downfile');
            downFile.src = downLoadPath;
          } catch (e) {
            _this3.$message.error('下载异常，请重试');
          }
        } else {
          _this3.$message('暂无笔录');
        }
      }).catch(function (_) {});
    }
  }, {
    key: "isCloud",
    get: function get() {
      return this.recordDetail.storage === 'cloud';
    }
  }, {
    key: "showStartTime",
    get: function get() {
      return this.$moment(this.recordDetail.startTime).format('YYYY/MM/DD HH:mm:ss').split(' ');
    }
  }, {
    key: "showEndTime",
    get: function get() {
      return this.$moment(this.recordDetail.endTime).format('HH:mm:ss');
    }
  }]);

  return VideoIframe;
}(Vue);

__decorate([Prop({
  required: true
})], VideoIframe.prototype, "recordDetail", void 0);

__decorate([Prop({
  required: true
})], VideoIframe.prototype, "index", void 0);

VideoIframe = __decorate([Component], VideoIframe);
export default VideoIframe;